import { configure } from "@cervval.js/client-html5-spa";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { buildDefaultErrorMessageService } from "@cervval.js/common/src/services/errorMessage.impl/default.errorMessage.service";
import { LoginClientMainService } from "../services/loginClientMainService.service";
import { setupApplicationLookAndFeel } from "./lookAndFeel";
import { getNavigationServiceConfiguration } from "./navigation";

setupApplicationLookAndFeel();// load bootstrap and app style
registerServices();

// Configure the single page application
configure({
    configureNavigation: getNavigationServiceConfiguration()
});

/**
 * Register services
 */
function registerServices(): void {
    injector.register(new LoginClientMainService());
    injector.register(buildDefaultErrorMessageService());
}